import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useUpdateReceivable } from "../../api/receivables";
import { useToast } from "../../components/ToastProvider";
import { Receivable } from "../../types/dtos";

export function EditReceivableModal({ receivable, onClose }: { receivable: Receivable | null; onClose: () => void }) {
  const [reference, setReference] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);

  const update = useUpdateReceivable();
  const toast = useToast();

  useEffect(() => {
    if (receivable) {
      setReference(receivable.reference);
      setDueDate(receivable.dueDate.slice(0, 10));
      setValue(String(receivable.value));
      setError(null);
    }
  }, [receivable]);

  if (!receivable) return null;

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!receivable) return;
    if (!reference.trim()) return setError("Informe a referência do título.");
    if (!dueDate) return setError("Informe o vencimento.");
    const numericValue = Number(value.replace(",", "."));
    if (!numericValue || numericValue <= 0) return setError("Informe um valor válido.");

    try {
      await update.mutateAsync({ id: receivable.id, input: { reference, dueDate, value: numericValue } });
      toast(`${receivable.code} atualizado.`);
      onClose();
    } catch {
      setError("Não foi possível salvar as alterações.");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>Editar {receivable.code}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div style={{ fontSize: 13 }} className="text-secondary">
            {receivable.customer.razaoSocial}
          </div>
          <div>
            <label className="form-label" style={{ fontSize: 12, fontWeight: 700 }}>
              Referência
            </label>
            <input className="form-control" value={reference} onChange={(e) => setReference(e.target.value)} />
          </div>
          <div className="row g-3">
            <div className="col-12 col-sm-6">
              <label className="form-label" style={{ fontSize: 12, fontWeight: 700 }}>
                Vencimento
              </label>
              <input type="date" className="form-control" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
            </div>
            <div className="col-12 col-sm-6">
              <label className="form-label" style={{ fontSize: 12, fontWeight: 700 }}>
                Valor (R$)
              </label>
              <input className="form-control" value={value} onChange={(e) => setValue(e.target.value)} placeholder="0,00" />
            </div>
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={update.isPending}>
            Salvar
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
